import { tv } from 'tailwind-variants';

const skeletonStyles = tv({
    slots: {
        base: `
        iris:h-full
        iris:w-full
        iris:[animation:fadeOutSkeleton_var(--comp-motion-duration-skeleton-loader)_var(--comp-motion-easing-skeleton-loader)_infinite]
        iris:bg-(--comp-color-content-skeleton-loader-default)
    `,
    },
    variants: {
        inverse: {
            false: {},
            true: {
                base: "iris:bg-(--comp-color-content-skeleton-loader-inverse)",
            },
        },
        variant: {
            circle: "iris:rounded-full",
            rectangle: "iris:rounded-(--comp-size-radius-skeleton-loader)",
            text: "iris:rounded-(--comp-size-radius-skeleton-loader)",
        },
    },
    defaultVariants: {
        type: "rectangle",
        inverse: false,
        className: "",
    },
});

export { skeletonStyles as default };
